import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,CloseOutlined,FileImageOutlined,VideoCameraOutlined } from '@ant-design/icons';
import ModalImage from "react-modal-image";
import axios from 'axios';


const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const storedFiles=[];

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			category_list: [],
			payee_list: [],
			category_details: [],
			loading: false,
			value: '',
			visible: '',
			visible_category: '',
			payee: '',
			visible1: '',
			visible2: '',
			visible3: '',
			payee_: '',
			popup_title: '',
			payee_value: '',
			category_value: '',
			header: '',
			amount: '',
			category: '',
			payee: '',
			payment_date: '',
			payment_status: '',
			reference_number: '',
			comment: '',
			description: '',
			split_amount: '',
			tax: '',
			total: '',
			conf_password: '',
			password: '',
			values: [2],
			selectedFiles:null,
			file_list: [],
		}
		
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		
	}
	
	
	
	goBack(){
		window.location.href = '/expenses/index';
	}
	
	render()

	{
	const { payee_,visible1,visible2, visible3, visible,payee, loading } = this.state;	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <div className="ant-upload-text snd-btn new">Add Files</div>
      </div>
    );	
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Privacy Policy</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Privacy Policy
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			 <div class="col s12 m12 ex-padd">
            <div class="container view-Profile child-profile">
			   <div class="col s12 m12 mb-20 iq-card card card-content iq-card">
                  <section class="invoice-list-wrapper section food mh-500">
					<div class="children mb-20 iq-card2 flow-root">
                    
						<div class="bb d-flex">
						  
						  <div class="col m12 no-padd">
								
									
								
								
								
						  </div>
						</div>
							
					</div> 
					
									
								

					
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
